import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CommonModule } from '@angular/common';

import { ShHtmlParserComponent } from '../../../core/html-parser/html-parser.component';
import { NavigationLinkDirective } from '../../directives/navigation-link/navigation-link-directive.module';
import { ShIconModule } from '../icon/icon.module';
import { LinkItem } from '../navigation-item/navigation-item.component';
import { NotificationType } from './entities/notification-types.entity';

export * from './entities/notification-types.entity';

@Component({
    standalone: true,
    selector: 'sh-notification',
    templateUrl: './notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShIconModule, CommonModule, NavigationLinkDirective, ShHtmlParserComponent]
})
export class ShNotificationComponent {
    private readonly baseClass: string = 'sh-notification';

    notificationClass: string = this.baseClass;

    @Input() title?: string;
    @Input() message!: string;
    @Input() messageList?: string[];
    @Input() linkList?: LinkItem[];
    @Input() icon?: string;
    @Input() closable?: string;

    @Input()
    set type(type: NotificationType) {
        this.setNotificationClass(type);
    }

    @Output() closeNotification: EventEmitter<void> = new EventEmitter();

    private setNotificationClass(type: NotificationType): void {
        switch (type) {
            case NotificationType.Default:
                this.notificationClass = this.baseClass;
                break;
            case NotificationType.Error:
                this.notificationClass = `${this.baseClass}--error`;
                break;
            case NotificationType.Warning:
                this.notificationClass = `${this.baseClass}--warning`;
                break;
            case NotificationType.Success:
                this.notificationClass = `${this.baseClass}--success`;
                break;
            case NotificationType.Update:
                this.notificationClass = `${this.baseClass}--update`;
                break;
            default:
                this.notificationClass = `${this.baseClass}`;
                break;
        }
    }

    public onClose(): void {
        this.closeNotification.next();
    }
}
